import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/portal'
  },
  // 登录页面
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Index.vue'),
    meta: { title: '登录', requireAuth: false }
  },
  // 门户页面
  {
    path: '/portal',
    name: 'Portal',
    component: () => import('@/views/portal/Index.vue'),
    meta: { title: '门户', requireAuth: true }
  },
  // 管理中心
  {
    path: '/admin',
    component: () => import('@/views/admin/Index.vue'),
    meta: { title: '管理中心', requireAuth: true },
    children: [
      {
        path: '',
        name: 'AdminCenter',
        component: () => import('@/views/admin/Home.vue'),
        meta: { title: '管理中心首页', requireAuth: true }
      },
      // 预约挂号
      { path: 'appointment', name: 'Appointment', component: () => import('@/views/appointment/List.vue'), meta: { title: '预约挂号', requireAuth: true } },
      // 快速预约管理
      { path: 'quick-appointment', name: 'QuickAppointment', component: () => import('@/views/quick-appointment/List.vue'), meta: { title: '快速预约管理', requireAuth: true } },
      // Banner广告管理
      { path: 'banner', name: 'Banner管理', component: () => import('@/views/banner/List.vue'), meta: { title: 'Banner广告管理', requireAuth: true } },
      // 医生诊断
      { path: 'diagnosis', name: 'Diagnosis', component: () => import('@/views/diagnosis/List.vue'), meta: { title: '医生诊断', requireAuth: true } },
      // 药房管理
      { path: 'pharmacy', name: 'Pharmacy', component: () => import('@/views/pharmacy/List.vue'), meta: { title: '药房管理', requireAuth: true } },
      // 化验管理
      { path: 'laboratory', name: 'Laboratory', component: () => import('@/views/laboratory/List.vue'), meta: { title: '化验管理', requireAuth: true } },
      // 化验结果详情
      { path: 'laboratory/result/:id', name: 'LaboratoryResult', component: () => import('@/views/laboratory/Result.vue'), meta: { title: '化验结果详情', requireAuth: true } },
      // 康复管理
      { path: 'rehabilitation', name: 'Rehabilitation', component: () => import('@/views/rehabilitation/List.vue'), meta: { title: '康复管理', requireAuth: true } },
      // 康复服务详情
      { path: 'rehabilitation/detail/:id', name: 'RehabilitationDetail', component: () => import('@/views/rehabilitation/Detail.vue'), meta: { title: '康复服务详情', requireAuth: true } },
      // 新增康复服务
      { path: 'rehabilitation/create', name: 'RehabilitationCreate', component: () => import('@/views/rehabilitation/Create.vue'), meta: { title: '新增康复服务', requireAuth: true } },
      // 编辑康复服务
      { path: 'rehabilitation/edit/:id', name: 'RehabilitationEdit', component: () => import('@/views/rehabilitation/Edit.vue'), meta: { title: '编辑康复服务', requireAuth: true } },
      // 收费管理
      { path: 'billing', name: 'Billing', component: () => import('@/views/charge/List.vue'), meta: { title: '收费管理', requireAuth: true } },
      // 患者管理
      { path: 'patient', name: 'Patient', component: () => import('@/views/patient/List.vue'), meta: { title: '患者管理', requireAuth: true } },
      // 客户管理
      { path: 'customer', name: 'Customer', component: () => import('@/views/customer/List.vue'), meta: { title: '客户管理', requireAuth: true } },
      // 医生管理
      { path: 'doctor', name: 'Doctor', component: () => import('@/views/doctor/List.vue'), meta: { title: '医生管理', requireAuth: true } },
      // 新增医生
      { path: 'doctor/create', name: 'CreateDoctor', component: () => import('@/views/doctor/Create.vue'), meta: { title: '新增医生', requireAuth: true } },
      // 医生头像维护
      { path: 'doctor/avatar-maintenance', name: 'AvatarMaintenance', component: () => import('@/views/doctor/AvatarMaintenance.vue'), meta: { title: '医生头像维护', requireAuth: true } },
      // 药品管理
      { path: 'medicine', name: 'Medicine', component: () => import('@/views/pharmacy/MedicineList.vue'), meta: { title: '药品管理', requireAuth: true } },
      // 部门管理
      { path: 'department', name: 'Department', component: () => import('@/views/department/DepartmentList.vue'), meta: { title: '部门管理', requireAuth: true } },
      // 统计报表
      { path: 'report', name: 'Report', component: () => import('@/views/statistics/Index.vue'), meta: { title: '统计报表', requireAuth: true } },
      // 系统设置
      { path: 'setting', name: 'Setting', component: () => import('@/views/admin/Setting.vue'), meta: { title: '系统设置', requireAuth: true } },
      // 医生排班管理
      { path: 'schedule', name: 'Schedule', component: () => import('@/views/schedule/List.vue'), meta: { title: '医生排班管理', requireAuth: true } },
      // 短信管理
      { path: 'sms', name: 'SmsManagement', component: () => import('@/views/admin/SmsManagement.vue'), meta: { title: '短信管理', requireAuth: true } }
    ]
  },
  // 403页面
  { path: '/403', name: 'Forbidden', component: () => import('@/views/error/403.vue'), meta: { title: '没有权限', requireAuth: false } },
  // 404页面
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面不存在', requireAuth: false }
  },
  // 医生详情页面（外部可直接访问）
  { path: '/doctor/detail/:id', name: 'DoctorDetail', component: () => import('@/views/doctor/Detail.vue'), meta: { title: '医生详情', requireAuth: true } },
  
  // 所有业务路由已在/admin下作为子路由定义
  // 以下是外部可直接访问的路由（非管理中心内使用）
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '融汇门诊管理系统'
  
  // 检查是否需要登录
  if (to.meta.requireAuth) {
    const token = localStorage.getItem('token')
    if (token) {
      // 检查是否需要权限验证
      if (to.meta.permission) {
        // 获取用户权限
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
        if (permissions.includes(to.meta.permission)) {
          next()
        } else {
          next('/403')
        }
      } else {
        // 不需要具体权限，直接放行
        next()
      }
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
})

export default router